import { useDrop } from 'react-dnd';
import { Box } from '@chakra-ui/react';
import { useRef, useState } from 'react';

const DragTypes = {
  FIELD: 'field',
};

const Dropable = ({
  children, id, index, canDropUp = true, canDropDown = true,
}) => {
  const ref = useRef(null);
  const [down, setDown] = useState(true);

  const [{ isOver }, drop] = useDrop({
    accept: DragTypes.FIELD,
    drop: () => ({ id, index, dropIndex: index }),
    collect(monitor) {
      return {
        isOver: !!monitor.isOver(),
      };
    },
    hover(item, monitor) {
      if (item.id === id) return;
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const clientOffset = monitor.getClientOffset();
      const middle = hoverBoundingRect.top + (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // eslint-disable-next-line no-param-reassign
      item.dropIndex = middle < clientOffset.y ? index + 1 : index;
      setDown(middle < clientOffset.y);
    },
  });

  drop(ref);
  return (
    <Box position="relative" ref={ref}>
      {canDropUp && isOver && !down && <Box backgroundColor="gray.200" w="100%" h="4px" position="absolute" top="-2px" />}
      {children}
      {canDropDown && isOver && down && <Box backgroundColor="gray.200" w="100%" h="4px" position="absolute" bottom="-2px" />}
    </Box>
  );
};

export default Dropable;
